module.exports = __webpack_public_path__ + "static/img/partner1.99127df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner1.png
// module id = Od0b
// module chunks = 0